export enum ContestVoteErrorCode {
  NotInContestContent = 'NotInContestContent',
  NotMatchContestContent = 'NotMatchContestContent',
  NotExistContentContest = 'NotExistContentContest',
  OverMaxVoteCountPerDay = 'OverMaxVoteCountPerDay',
  OverMaxVoteCountPerCategoryPerDay = 'OverMaxVoteCountPerCategoryPerDay',
  AlreadyVoteContent = 'AlreadyVoteContent',
  NotPeriod = 'NotPeriod',
  Unknown = 'Unknown',
}

export enum ContestId {
  Contest2023 = 1,
  Contest2024 = 2,
  Contest2025 = 3,
  Contest2026 = 4,
}

export enum ExtraStage {
  None = '',
  Contest2024Top30 = 'Contest2024Top30',
  Contest2024 = 'Contest2024',
}
